import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import moment from 'moment';

import { addLocaleData } from 'react-intl';
import enLocale from 'react-intl/locale-data/en';
import fiLocale from 'react-intl/locale-data/fi';
import svLocale from 'react-intl/locale-data/sv';

import createStore from './store/createStore';
import './styles/core.less';

// import getParams from './lib/getParams';
// import exists from './lib/exists';
// import { setToken, getToken } from './lib/challengeToken';
// import { shouldAllowUnauthorized } from 'lib/authorizedRoutes';
import browserLanguage from 'lib/browserLanguage';

// Create a history instance
const history = createBrowserHistory();

// Testing builder again...and again!

// Store Initialization
// ------------------------------------
export const store = createStore(window.__INITIAL_STATE__, history);

// Localization setup
// ------------------------------------
addLocaleData([...enLocale, ...fiLocale, ...svLocale]);

moment.locale(browserLanguage);

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let render = () => {
  const App = require('./components/App').default;

  ReactDOM.render(<App store={store} history={history} />, MOUNT_NODE);
};

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      const RedBox = require('redbox-react').default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept(['./components/App', './layouts/ApplicationLayout', './routes'], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      }),
    );
  }
}

/*
  Handling the challenge token and persisting it in localStorage.
  TODO: Needs to be also stored in redux because private browsing in Safari and iOS
  does not support localStorage. The future fetching order will be: Redux State -> localStorage -> Redirect
//  */
// const handleToken = () => {
//   const { history } = window;
//   const tokenFromLocation = getParams(location.search).challengeT || null;
//   const tokenFromStorage = getToken();

//   if (exists(tokenFromLocation)) {
//     setToken(tokenFromLocation);
//     history.replaceState(history.state, '', '/');
//     return;
//   }

//   if (!exists(tokenFromStorage) && !shouldAllowUnauthorized(location.pathname)) {
//     location.replace(LOGIN_URL);
//   }
// };

// Call the above function
// handleToken();

// Let's Go!
// ------------------------------------
if (!__TEST__) render();
